module.exports = __webpack_public_path__ + "static/img/lv2.bbd463c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/other/lv2.png
// module id = kaSx
// module chunks = 1